export default function AIinMessaging() {
  const doItems = [
    { icon: 'ri-speed-line', title: 'Ускорять ответы', desc: 'ChatGPT помогает быстро формулировать ответы на типовые вопросы. Менеджер тратит меньше времени на рутину и больше — на сложные диалоги.' },
    { icon: 'ri-lightbulb-line', title: 'Генерировать варианты', desc: 'ИИ предлагает альтернативные формулировки для сложных ситуаций: как ответить на возражение, как переформулировать ценность, как вернуть клиента.' },
    { icon: 'ri-file-check-line', title: 'Проверять сообщения', desc: 'ИИ анализирует тональность и структуру сообщения до отправки: не слишком ли формально, нет ли двусмысленности, всё ли понятно.' },
    { icon: 'ri-bar-chart-line', title: 'Анализировать переписки', desc: 'ИИ может проанализировать диалог и показать: где потеряна инициатива, где слабая аргументация, какой следующий шаг был бы оптимальным.' },
  ];

  const dontItems = [
    { icon: 'ri-close-circle-line', title: 'Полная автозамена менеджера', desc: 'ИИ не понимает контекст бизнеса клиента, не чувствует нюансов и не может выстроить доверительные отношения. Чат-бот не заменит живого продавца.' },
    { icon: 'ri-emotion-unhappy-line', title: 'Потеря человечности', desc: 'Сгенерированные ответы звучат шаблонно. Клиенты чувствуют робота и теряют доверие. ИИ — ассистент, а не замена менеджера.' },
    { icon: 'ri-shield-cross-line', title: 'Доверие ИИ в сложных переговорах', desc: 'В переговорах с ЛПР, в сложных сделках и в работе с претензиями нужен живой опытный менеджер. ИИ не заменит эмпатию и стратегическое мышление.' },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-teal-50 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-robot-line"></i>
            Технологии в продажах
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Использование ИИ в переписке
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            ChatGPT и другие ИИ-инструменты могут стать мощным помощником менеджера. Но важно понимать, где ИИ помогает, а где нужен только живой человек.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 max-w-5xl mx-auto">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 bg-teal-600 rounded-xl flex items-center justify-center">
                <i className="ri-check-line text-white text-lg"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900">Что можно доверить ИИ</h3>
            </div>
            <div className="space-y-4">
              {doItems.map((item, i) => (
                <div key={i} className="bg-teal-50 rounded-xl p-4 md:p-5 border border-teal-100">
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 bg-teal-600/10 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className={`${item.icon} text-teal-600 text-sm`}></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-gray-900 mb-1">{item.title}</h4>
                      <p className="text-xs text-gray-600 leading-relaxed">{item.desc}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 bg-red-500 rounded-xl flex items-center justify-center">
                <i className="ri-close-line text-white text-lg"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900">Что нельзя доверять ИИ</h3>
            </div>
            <div className="space-y-4">
              {dontItems.map((item, i) => (
                <div key={i} className="bg-red-50 rounded-xl p-4 md:p-5 border border-red-100">
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className={`${item.icon} text-red-500 text-sm`}></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-gray-900 mb-1">{item.title}</h4>
                      <p className="text-xs text-gray-600 leading-relaxed">{item.desc}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="max-w-3xl mx-auto mt-12 bg-gradient-to-br from-teal-600 to-teal-700 rounded-2xl p-8 md:p-10 text-center">
          <p className="text-lg md:text-xl text-white leading-relaxed font-medium">
            ИИ — это инструмент, а не замена продавца. Мы учим использовать его грамотно: ускорять рутину, находить лучшие формулировки и освобождать время для того, что ИИ не умеет — выстраивать доверительные отношения с клиентом.
          </p>
        </div>
      </div>
    </section>
  );
}